import { UserType } from 'types/user';

declare global {
  interface Window {
    heap: {
      addUserProperties: (userProps: Record<string, unknown>) => void;
      identify: (id: string) => void;
      resetIdentity: () => void;
      track: (eventName: string, properties?: Record<string, unknown>) => void;
    };
  }
}

export function resetIdentity() {
  window.heap.resetIdentity();
}

// Associates user_id to Heap identity
export function initUser(user: UserType) {
  window.heap.identify(user.id);
  window.heap.addUserProperties({
    company_id: user.company_id,
    group_id: user.group_id,
    id: user.id,
    is_chownow_admin: user.is_chownow_admin,
    is_region_admin: user.is_region_admin,
    is_super_admin: user.is_super_admin,
  });
}
